export const styles = {
    background: {
        paddingBottom: 40,
        backgroundImage: "linear-gradient(to top, #1D3450 30%,#1B1D25 100%)",
    },

};